export default __webpack_public_path__ + "static/media/trusted-by.463e39cb.svg";